module.exports = __webpack_public_path__ + "static/media/login_bg.721e1b7e.png";